module.exports = __webpack_public_path__ + "img/material-symbols_sms-outline.d9c18f75.svg";